(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["healrize_review_preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('healrize-review-preview')) {
  customElements.define('healrize-review-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.events = new AbortController();
      const signal = this.events.signal;
      const grid = this.querySelector('.demo-grid');
      const sort = this.querySelector('[data-demo-order]');
      const photos = this.querySelector('[data-demo-photos]');
      const dialog = this.querySelector('dialog');
      const form = this.querySelector('form');
      const cards = () => [...grid.querySelectorAll('.demo-review')];
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.isConnected) return;
          grid.dataset.masonry = 'true';
          cards().forEach(card => {
            if (card.hidden) return;
            const span = 'span ' + Math.ceil(card.querySelector('.demo-review-inner').getBoundingClientRect().height + 12);
            if (card.style.gridRowEnd !== span) card.style.gridRowEnd = span;
          });
        });
      };
      this.observer = new ResizeObserver(this.schedule);
      cards().forEach(card => this.observer.observe(card.querySelector('.demo-review-inner')));
      grid.querySelectorAll('img').forEach(img => img.addEventListener('load', this.schedule, {signal}));
      window.addEventListener('resize', this.schedule, {signal});
      if (document.fonts) document.fonts.ready.then(this.schedule);
      const arrange = () => {
        cards().sort((a, b) => {
          const sequence = Number(a.dataset.sequence) - Number(b.dataset.sequence);
          if (sort.value === 'newest') return -sequence;
          if (sort.value === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || sequence;
          if (sort.value === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || sequence;
          return sequence;
        }).forEach(card => {
          card.hidden = photos.checked && card.dataset.photo !== 'true';
          grid.appendChild(card);
        });
        this.schedule();
      };
      sort.addEventListener('change', arrange, {signal});
      photos.addEventListener('change', arrange, {signal});
      this.querySelector('[data-demo-write]').addEventListener('click', () => dialog.showModal(), {signal});
      this.querySelector('[data-demo-close]').addEventListener('click', () => dialog.close(), {signal});
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, {signal});
      const baseCount = Number(this.dataset.baseCount);
      let added = 0;
      form.addEventListener('submit', event => {
        event.preventDefault();
        const card = this.querySelector('[data-demo-card]').content.firstElementChild.cloneNode(true);
        const rating = Math.min(5, Math.max(1, Number(this.querySelector('[data-demo-rating]').value)));
        card.dataset.sequence = String(cards().length);
        card.dataset.rating = String(rating);
        card.querySelector('strong').textContent = this.querySelector('[data-demo-name]').value;
        card.querySelector('.demo-stars').textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
        card.querySelector('h3').textContent = this.querySelector('[data-demo-title]').value;
        card.querySelector('.demo-text').textContent = this.querySelector('[data-demo-body]').value;
        grid.appendChild(card);
        this.observer.observe(card.querySelector('.demo-review-inner'));
        added += 1;
        this.querySelector('[data-demo-total]').textContent = this.dataset.countLabel.replace('__COUNT__', String(baseCount + added));
        sort.value = 'newest';
        photos.checked = false;
        arrange();
        dialog.close();
        form.reset();
        const toast = this.querySelector('[role="status"]');
        toast.textContent = this.dataset.addedMessage;
        toast.style.display = 'block';
        clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => { toast.style.display = 'none'; }, 3600);
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const card = cards().find(item => item.dataset.blockId === event.detail.blockId);
        if (!card) return;
        sort.value = 'featured';
        photos.checked = false;
        arrange();
        requestAnimationFrame(() => card.scrollIntoView({block: 'nearest', behavior: 'auto'}));
      }, {signal});
      this.schedule();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      clearTimeout(this.toastTimer);
      this.frame = null;
      this.ready = false;
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdrn-report-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pdrn-report-gallery')) {
    customElements.define('pdrn-report-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.links = [...this.querySelectorAll('[data-report-open]')];
        this.dialog = this.querySelector('dialog');
        this.documentArea = this.querySelector('[data-report-document]');
        this.counter = this.querySelector('[data-report-counter]');
        this.previous = this.querySelector('[data-report-prev]');
        this.next = this.querySelector('[data-report-next]');
        this.links.forEach((link, index) => link.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !this.dialog.showModal) return;
          event.preventDefault();
          this.opener = link;
          this.showPage(index);
          this.dialog.showModal();
        }, { signal }));
        this.querySelector('[data-report-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.previous.addEventListener('click', () => this.showPage(this.index - 1), { signal });
        this.next.addEventListener('click', () => this.showPage(this.index + 1), { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' && this.index > 0) { event.preventDefault(); this.showPage(this.index - 1); }
          if (event.key === 'ArrowRight' && this.index < this.links.length - 1) { event.preventDefault(); this.showPage(this.index + 1); }
        }, { signal });
        this.dialog.addEventListener('close', () => this.opener?.focus({ preventScroll:true }), { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
      showPage(index) {
        const link = this.links[index];
        if (!link) return;
        this.index = index;
        this.querySelector('[data-report-dialog-title]').textContent = link.dataset.reportTitle;
        const documentImage = new Image();
        documentImage.src = link.href;
        documentImage.alt = link.dataset.reportAlt;
        const thumbnail = link.querySelector('img');
        documentImage.width = thumbnail.width;
        documentImage.height = thumbnail.height;
        this.documentArea.replaceChildren(documentImage);
        this.documentArea.scrollTop = 0;
        this.counter.textContent = this.counter.dataset.reportPattern.replace('[number]', index + 1).replace('[total]', this.links.length);
        this.previous.disabled = index === 0;
        this.next.disabled = index === this.links.length - 1;
        this.querySelector('[data-report-original]').href = link.href;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
